import { render, staticRenderFns } from "./adf-send.vue?vue&type=template&id=20d83d6a&scoped=true&"
import script from "./adf-send.vue?vue&type=script&lang=js&"
export * from "./adf-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d83d6a",
  null
  
)

export default component.exports